import { EcommerceAPI } from "../Client";
import { appendProcessedFile, appendProcessedFiles } from "../../../utils/imageUploadProcessor";

export const multipleFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();

    await appendProcessedFiles(formData, "files", payload.files, {
      mimeType: payload.imageMimeType,
    });
    if (payload?.productId) {
      formData.append("productId", payload?.productId.toString());
    }

    console.log("formData ", formData, payload.files);

    const response = await EcommerceAPI.post(`/api/product/upload/files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFileApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(
      `/api/product/file?key=${payload?.key || ""}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/api/products/all`, {
      params: {
        page: payload?.page || 0,
        size: payload?.size || 10,
        search: payload?.keyword?.trim() || "",
        sku: payload?.sku?.trim() || "",
        searchType: payload?.searchMode || "all",
        categoryType: payload?.category ?? "",
        sortBy: payload?.sortby || "",
        sortDir: payload?.sortdir || "",
        isActive: payload?.isActive ?? "",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllSellerProductApi = async (payload) => {
  try {
    console.log("category 3.2", payload)
    const response = await EcommerceAPI.get(`/api/user/products`, {
      params: {
        page: payload?.page || 0,
        size: payload?.size || 10,
        search: payload?.keyword?.trim() || "",
        categoryType: payload?.category ?? "",
        sortBy: payload?.sortby || "",
        sortDir: payload?.sortdir || "",
        isActive: payload?.isActive ?? "",
        sku: payload?.sku?.trim() || "",
        searchType: payload?.searchMode || "all",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleProductApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/api/product/${payload?.productId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDeliveryZoneApi = async () => {
  try {
    const response = await EcommerceAPI.get(`/api/product/delivery/zone`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadProductApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/api/product`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductExtraUploadsApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.delete(`/api/product/extra/uploads`, {
      params: {
        productId: payload?.productId,
        deleteDemoVid: payload?.deleteDemoVid,
        deleteHurryUpVid: payload?.deleteHurryUpVid,
        deletePreviewUpload: payload?.deletePreviewUpload,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const cloneProductApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(`/api/product/clone`, null, {
      params: {
        productName: payload?.productName,
        prevProductId: payload?.prevProductId,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const postProductFloatVideoApi = async (payload = {}) => {
  try {
    const { productId, ...body } = payload || {};
    const response = await EcommerceAPI.post(
      `/api/product/float/video`,
      body,
      {
        params: {
          productId,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/api/product`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/api/product/${payload?.productId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const activationProductApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/api/product/${payload?.productId || 0}/active?isActive=${payload?.isActive
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductPriorityApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/api/product/priority`,
      null,
      {
        params: {
          productId: payload?.productId,
          priority: payload?.priority,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadColorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/api/product/color?productId=${payload?.productId || 1}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateColorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/api/product/color?productId=${payload?.productId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteColorApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(
      `/api/product/color?productId=${payload?.productId || 0}&colorId=${payload?.colorId || 0}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadSizeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/api/product/color/size?colorId=${payload?.colorId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSizeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/api/product/color/size?colorId=${payload?.colorId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postProductSizeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(
      `/api/product/size?productId=${payload?.productId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductSizeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/api/product/size?productId=${payload?.productId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSizeApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(
      `/api/product/color/size?sizeId=${payload?.sizeId || 0}&colorId=${payload?.colorId || 0}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadPreivewIconAPI = async (file) => {
  const formData = new FormData();
  await appendProcessedFile(formData, "files", file);

  return EcommerceAPI.post("/api/product/upload/single/file", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};
